<template>
  <div>
    <div class="container">
      <div class="inner">
        <div class="back-wrapper">
          <button class="secondary back" @click="goToStep1">{{ $t('view.component.common.buttonBack') }}</button>
        </div>
        <div class="top-bar">
          <h1 class="main-title">{{ $t('view.component.topup.auto.header') }}</h1>
          <p class="subtitle">
            {{ $t('view.component.topup.auto.subTitle') }}
            <a class="bold" @click="toggleAutoTopupSidebar" v-html="$t('view.component.topup.auto.howItWorks')"></a>
          </p>
        </div>
        <TopupAutoFormStep2 />
      </div>
      <Sidebar v-if="autoTopupSidebarVisible"
               :sidebar-visible="autoTopupSidebarVisible"
               @sidebarClose="toggleAutoTopupSidebar">
        <AutoTopupSidebar />
      </Sidebar>
    </div>
  </div>
</template>

<script>
import TopupAutoFormStep2 from '@/orange/components/Topup/Auto/FormStep2'
import AutotopupMixin from '@/orange/mixins/autotopup.mixin'
import Sidebar from '@/orange/components/common/Sidebar'
import AutoTopupSidebar from '@/orange/components/Topup/Auto/AutoTopupSidebar'
import { GoogleAnalytics } from '@/common/class/ga.class'

export default {
  name: 'TopupAutoStep2View',
  mixins: [AutotopupMixin],
  components: {
    AutoTopupSidebar,
    Sidebar,
    TopupAutoFormStep2
  },
  mounted () {
    GoogleAnalytics.sendEvent({ event: 'autodoladowanie_login', event_name: 'Wlacz_autodoladowanie', step: 'step_2' })
  }
}
</script>

<style lang="scss" src="../../../assets/scss/components/_auto_topup-main.scss" scoped></style>
